// 简体中文语言包
export default {
	// 导航
	nav: {
		home: '首页',
		company: '公司简介',
		about: '牌照资料',
		products: '产品介绍',
		download: '软件下载',
		news: '资讯公告',
		contact: '联系我们',
	},

	// 顶部栏
	topbar: {
		hotline: '服务热线',
		openAccount: '线上开户',
		demoTrading: '模拟交易',
		bookAccount: '预约开户',
	},

	// Hero区域
	hero: {
		title1: '领航行业趋势构筑顶尖国际化投资生态',
		desc1: '实时洞悉市场脉搏，依托金融科技深挖价值洼地。整合全球优质资源，搭建稳定可靠的交易体系，为客户财富稳健增长保驾护航。',
		title2: '专业金融服务智慧投资未来',
		desc2: '前瞻国际为您提供全球化的交易服务，助您在金融市场中把握每一个机遇',
		title3: '凝聚全球智慧赋能投资者多元发展路径',
		desc3: '集结全球金融领域专家，共享前沿策略与实战经验。定制创新型解决方案，科学管理风险，精准发掘潜力投资赛道。',
	},

	// 公司简介
	company: {
		companyName: '前瞻金融投资管理国际有限公司',
		badge: '前瞻国际',
		subtitle: '香港证监会持牌法团全球金融市场覆盖',
		coverage: '全球金融市场覆盖',
		btnText: '了解前瞻国际',
		introTitle: '公司介绍',
		profileSub: 'COMPANY PROFILE',
		intro: '前瞻金融投资管理国际有限公司成立于2019年，是一家专业的金融服务机构。作为香港证监会的认可持牌法团，我们致力为客户提供全面的证券交易服务。',
		intro2: '凭借丰富的行业经验和专业的团队，我们为客户提供精准的市场分析和高效的交易执行，帮助客户在全球金融市场中实现投资目标。',
		introFull1: '前瞻金融投资管理国际有限公司持有香港证券及期货事务监察委员会牌照，具备从事《证券及期货条例》中规定的第一类受规管活动（证券交易）、第四类受规管活动（就证券提供意见）及第九类受规管活动（提供资产管理）的资格，香港证监会中央编号为BRV554。',
		introFull2: '中规定的一类受监管活动《证券交易》、第类受监管活动《就证券提供意见》及第九类受监管活动《提供资产管理》的资格，香港证监会中央编号为BRV554。',
		introFull3: '',
	},

	// 产品介绍
	product: {
		productTitle: '业务架构',
		descFull: '  随着全球资产配置需求持续提升，量化投资、智能投顾与金融科技正成为投资管理行业的重要发展方向。前瞻金融投资管理国际有限公司围绕量化投资研究、智能策略服务及金融科技应用，进一步梳理业务布局，形成了以前瞻国际为核心、以前瞻量化为策略品牌、以前瞻致驱为运营支撑的协同发展架构。',
		descFull2: '  在这一体系中，前瞻量化扮演着重要角色。作为前瞻金融投资管理国际有限公司重点打造的量化投资研究与智能策略服务品牌，前瞻量化主要聚焦量化模型研发、市场数据分析、策略组合构建、风控体系建设以及智能化投资辅助工具开发。相比传统投研模式，前瞻量化更强调数据驱动、模型验证和纪律化执行，希望通过更加系统的方法，为投资者提供理性、清晰、可追踪的投资决策支持。',
		descFull3: '  前瞻致驱则承担着前瞻国际在内地的运营管理与技术服务支持职能。其工作重点包括品牌运营、技术协同、市场服务、投研内容支持及客户服务体系建设等。通过香港机构的专业资质、量化品牌的策略研发能力，以及内地运营主体的服务支持，三者之间形成了较为清晰的分工关系。',
	},

	// 产品服务（Products页面）
	products: {
		bannerTitle: '产品介绍',
		bannerDesc: '证券作为现代金融体系的核心风险管理工具，帮助买卖双方有效规避价格波动风险，是连接实体经济与虚拟资本的关键纽带。',
		sectionTitle: '证券业务介绍',
		sectionSub: 'GLOBAL SECURITIES INTRODUCTION',
		introFull: '作为现代金融体系的核心投资工具，证券通过标准化的股票、债券、基金等产品，为企业提供直接融资渠道，为投资者搭建资产增值平台。自全球证券市场规范化发展以来，历经百年演进，已形成覆盖全球主要经济体的多层次资本市场体系。随着金融全球化与数字化发展，环球证券市场成为连接实体经济与社会资本的核心桥梁，全球证券市场总市值规模持续稳定增长。',
		marketTitle: '市场功能与结构演变',
		marketIntro: '环球证券市场兼具融资服务与资产配置双重功能：',
		assetGrowth: '资产增值',
		assetGrowthDesc: '投资者通过投资股票、基金等证券产品，分享优质企业成长红利，实现长期资产保值与增值，是全球主流的财富管理方式。',
		wealthMgmt: '财富管理',
		wealthMgmtDesc: '依托港股、美股、A股等全球主要市场，支持多样化投资组合配置，T+0/ T+1灵活交易机制，满足个人与机构的多元化财富管理需求。',
		systemTitle: '产品体系：从基础股票到综合金融产品',
		systemIntro: '当前环球证券市场呈现三大特征：',
		categoryTitle: '品类多元化',
		featStock: '股票产品',
		featStockDesc: '覆盖港股、美股、沪深A股等全球主流市场，包含蓝筹股、科技股、医药股等全品类标的，满足不同风险偏好投资者需求。',
		featFund: '基金理财',
		featFundDesc: '提供公募基金、私募基金、ETF等产品，由专业机构管理，分散投资风险，适合稳健型投资者进行长期配置。',
		featBond: '债券产品',
		featBondDesc: '政府债券、企业债券、可转债等固定收益产品，收益稳定、风险较低，是资产配置中重要的避险工具。',
		overlayTitle: '专业合规',
		overlayDesc: '持有香港证监会(SFC)1号及4号、9号牌照',
		serviceProviderTitle: '作为专业环球证券服务商',
		serviceProviderDesc: '作为专业环球证券服务商，前瞻国际整合全球核心交易所资源，包括香港联交所、纽约证券交易所、纳斯达克等，为客户提供覆盖全球主流证券品种的一站式交易服务。通过合规高效的服务通道，投资者可便捷参与港股、美股、A股等市场交易，享受低佣金、透明定价与专业的投资服务。',
		trendTitle: '发展趋势与价值',
		trendDesc: '当前，环球证券市场持续向数字化、全球化、多元化发展，ESG投资、智能投顾等创新服务快速普及。随着监管体系持续完善与投资者专业度提升，证券市场作为全球资本配置核心平台的价值将进一步凸显，助力个人与机构把握全球投资机遇，实现财富稳健增长。',
	},

	// 软件下载（Download页面）
	download: {
		bannerTitle: '软件下载',
		bannerDesc: '下载官方认证的交易软件与辅助工具，助力您稳定、高效开展各类投资交易操作。',
		sectionTitle: '交易软件下载',
		sectionSub: 'TRADING SOFTWARE DOWNLOAD',
		platformDesc: '前瞻致驱采用先进的系统架构与开发技术，具备多点部署、主中心统一管理、分布式运行及多中心协同能力，可根据实际业务需求灵活配置灾备、热备、冗余架构及跨区域服务方案，保障系统稳定运行与业务连续性。',
		serviceTitle: '为用户提供更好、更专业的软件服务平台',
		serviceDesc: '前瞻致驱承担前瞻国际在内地的运营管理与技术服务支持职能，围绕品牌运营、技术协同、市场服务、投研内容及客户服务体系建设开展工作。',
		appSubtitle: '前瞻致驱APP客户端下载',
		iosBadge: '苹果',
		iosDownloadText: 'App Store搜索：前瞻致驱',
		androidBadge: '安卓',
		androidDownloadText: '应用商店搜索：前瞻致驱',
		guideTitle: '使用指南',
		step1Title: '下载安装',
		step1Desc: '根据您的设备类型选择对应的客户端版本进行下载并安装。',
		step2Title: '账号登录',
		step2Desc: '使用开户时获取的账号和密码登录交易平台。首次登录需修改密码。',
		step3Title: '开始交易',
		step3Desc: '浏览行情、研究分析后，即可开始您的交易之旅。',
	},

	// 数据统计
	stats: {
		compliance: '专业合规',
		license: '持有香港证监会(SFC)1号及4号、9号牌照',
		exchanges: '全球主力交易所',
		founded: '成立年份',
		coverage: '全球市场覆盖（小时）',
	},

	// 关于我们（牌照信息）
	about: {
		bannerTitle: '牌照资料',
		sectionTitle: '牌照资料',
		sectionSub: 'ABOUT QIANZHAN',
		licenseTitle: '牌照信息',
		licenseDesc1: '前瞻金融投资管理国际有限公司持有香港证券及期货事务监察委员会（SFC）颁发的受规管活动牌照，具备从事《证券及期货条例》中规定的第一类受规管活动（证券交易）、第四类受规管活动（就证券提供意见）及第九类受规管活动（提供资产管理）的资格。',
		licenseDesc2: '中央编号为BNG583，是经香港证监会正式认可的专业持牌法团，严格遵守相关监管规定，确保客户资金安全与交易公平。',
		complianceTitle: '监管合规',
		complianceDesc: '作为香港证券及期货事务监察委员会（SFC）认可的持牌法团，我们严格遵守《证券及期货条例》及相关监管规定：',
		compliance1: '客户资产独立托管，与公司资产完全隔离',
		compliance2: '定期接受香港证监会审计与检查',
		compliance3: '完善的内部风险控制体系',
		compliance4: '透明的费用结构与交易规则',
		licenseTypes: '第1/4/9类牌照',
		centralNo: '中央编号',
		regulator: '监管机构',
	},

	// 客户服务
	service: {
		title: '客户服务',
		subtitle: '我们提供全方位的客户服务，确保您的交易体验顺畅便捷',
		download: {
			title: '软件下载',
			desc: '下载我们的交易软件，随时随地开展交易',
		},
		deposit: {
			title: '出入金服务',
			desc: '多种资金进出渠道，满足您的资金管理需求',
		},
		account: {
			title: '在线开户',
			desc: '简单快速完成开户流程，开启您的投资之旅',
		},
	},
	news: {
		"bannerTitle": "资讯公告",
		"bannerDesc": "追踪公司动态，掌握市场前沿的金融策略",
		"tabCompany": "公司公告",
		"tabMedia": "媒體聚焦",
		"tabNotice": "通知公告",
		"hotArticlesTitle": "热门文章",
		"backToList": "← 返回列表"
	},
	// 联系我们（Contact页面）
	contact: {
		bannerTitle: '联系我们',
		bannerDesc: '无论您有任何投资相关的问题或需求，我们都愿意倾听并为您提供专业支持。欢迎通过多种方式与我们取得联系。',
		sectionTitle: '联系方式',
		sectionSub: 'CONTACT US',
		introText: '前瞻国际致力于为全球投资者提供专业的证券交易服务与投资咨询支持。无论您是个人投资者还是机构客户，我们的专业团队都将竭诚为您服务。您可以通过以下方式与我们取得联系，我们将尽快回复您的咨询。',
		emailTitle: '电子邮件',
		emailValue: 'invisionasset@gmail.com',
		addressTitle: '公司地址',
		addressValueCN: '香港尖沙咀广东道28号力宝太阳广场4楼408C室',
		addressValueEN: 'Unit 408C, 4/F, Lippo Sun Plaza, 28 Canton Road, Tsim Sha Tsui, Hong Kong',
		mapTitle: '公司位置',
		mapDesc: '查看我们在香港九龙尖沙咀地理位置',
	},

	// 底部
	footer: {
		copyright: 'Copyright © 2019 前瞻金融投资管理国际有限公司 版权所有 ',
	},

	// 页面标题
	pages: {
		companyTitle: '公司简介',
		aboutTitle: '牌照资料',
		productsTitle: '产品介绍',
		downloadTitle: '软件下载',
		newsTitle: '资讯公告',
		contactTitle: '联系我们',
	},

	// 语言切换
	langSwitch: {
		zhCN: '简',
		zhTW: '繁',
	},
}